var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#707070",
      fill: "#3b5175"
    },
    d: "M0 0h24v24H0z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".c{fill:none}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0 0h24m0 24H0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.692 8.667h10l-5.01 6.3Zm-2.75-.39c2.02 2.59 5.75 7.39 5.75 7.39v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6s3.72-4.8 5.74-7.39a1 1 0 0 0-.79-1.61H7.732a1 1 0 0 0-.79 1.61Z",
    transform: "translate(-2.692 -2.667)",
    style: {
      fill: "#3b5175"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0 0h24v24H0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.667 10h10l-5.01 6.3Z",
    transform: "translate(-4.667 -4)",
    style: {
      opacity: 0.3,
      fill: "#3b5175"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSmall);
export default __webpack_public_path__ + "static/media/filter-small.c0472959cc0ab7a611a00a2ac51038f8.svg";
export { ForwardRef as ReactComponent };